// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| ADMINISTRACION MENU ITEMS ||============================== //

const administracionAdmin = {
    id: 'administracionAdmin',
    title: 'Administracion',
    type: 'group',
    children: [
        {
            id: 'empresas',
            title: 'Empresas',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'lista_empresa',
                    title: 'Lista Empresas',
                    type: 'item',
                    url: '/company/list-company-admin'
                },
                {
                    id: 'nueva_empresa',
                    title: 'Nueva Empresa',
                    type: 'item',
                    url: '/company/new-company/0'
                },                
            ]
        },
    ]
};

export default administracionAdmin;
